import {
  Button,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Textarea,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CancelOtpAPI, CheckOTPAPI, GenerateNumberAPI, GenerateOtpAPI } from "../utils/api";
import { FiCopy } from "react-icons/fi";
import Countdown from "react-countdown";
import { AppContext } from "../context/AppContext";

function getInitialTime(serverName) {
  if (serverName == 'server5' || serverName == 'server3') {
    return 5 * 60
  } else if (serverName == 'server1') {
    return 15 * 60
  } else {
    return 20 * 60;
  }
}
const formatTime = time => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
const GetOtpCard = ({ Token, selectService, server, requestInProgress, setRequestInProgress, cancelBtnRequestInProgress, setCancelBtnRequestInProgress }) => {
  const inputRef = useRef(null);
  const { setBalance, handleLogout } = useContext(AppContext);
  const textAreaRef = useRef();
  const toast = useToast();
  const [remainingTime, setRemainingTime] = useState(getInitialTime(server));
  const [showTime, setShowTime] = useState(false);
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [expired, setExpired] = useState(false);
  const [resend, setResend] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const requestRef = useRef(false);
  const [ws, setws] = useState(null);
  const [currentNumber, setCurrentNumber] = useState({
    serialNumber: "",
    mobileno: "",
    mobileId: "",
  });
  const serialNumberRef = useRef(null);
  const mobileIdRef = useRef(null);
  const CopyToClipBoard = () => {
    let numberForCopy = "";
    for (let i = 3; i < inputRef.current.value.length; i++) {
      numberForCopy += inputRef.current.value[i];
    }
    if (inputRef.current.value != "") {
      navigator.clipboard
        .writeText(numberForCopy)
        .then(() => {
          toast({
            status: "info",
            title: `${numberForCopy} number copied`,
            isClosable: true,
            duration: 1000,
            position: "bottom-right",
          });
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
          toast({
            status: "error",
            title: `errror in copying number ${inputRef.current.value}`,
            isClosable: true,
            duration: 1000,
          });
        });
    }
  };
  const handleOTP = (myResend = false, socket) => {
    if (serialNumberRef.current != "" && socket) {
      // console.log('again',intervalRef.current);
      CheckOTPAPI(
        socket,
        {
          serialNumber: serialNumberRef.current,
          mobileId: mobileIdRef.current,
          businessCode: selectService.code,
          server,
          resend: myResend
        },
      )
        .then((res) => {
          requestRef.current = true;
          if (res && res.message == "OTP Successfully Generated!") {
            let otpMessage = res.otpMessage;
            if (textAreaRef.current) {
              if (textAreaRef.current.value) {
                textAreaRef.current.value = otpMessage + "\n" + textAreaRef.current.value;
              } else {
                textAreaRef.current.value = otpMessage;
              }
            }
            // clearInterval(intervalRef.current);
            // if (intervalRef.current != null) {
            setResendLoading(false);
            toast({
              title: "Otp fetched successfully",
              description: "Now you can use this otp into your service",
              status: "success",
              isClosable: true,
              duration: 2000,
            });
            // }
            // intervalRef.current = null;
            setShowTime(false);
            setResend(true);
          };
        })
        .catch((err) => {
          // clearInterval(intervalRef.current);
          // intervalRef.current = null;
          setResendLoading(false);
          console.log(err, "error saying");
          setShowTime(false);
          handleLogout(err);
        });
    }
  };
  const startChecking = (myResend = false) => {
    const socket = new WebSocket(
      `${process.env.REACT_APP_WS_API}/check-otp?token=${Token}`
    );
    setTimeout(() => {
      if (socket) {
        setws(socket);
        console.log("start checking for otp ....");
        handleOTP(myResend, socket);
      }
    }, 5000)
  };
  const cancelBtn = () => {
    if (ws != null) {
      ws?.close();
      console.log("ws connection closed for ", currentNumber.mobileno);
    }
    toast({
      title: `Otp request canceled`,
      status: "warning",
      isClosable: true,
    });
    setCancelBtnRequestInProgress(true);
    setShowTime(false);
    setRemainingTime(getInitialTime(server));
    setResend(false);
    setResendLoading(false);
    inputRef.current.value = null;
    CancelOtpAPI({
      serialNumber: serialNumberRef.current,
      server,
      mobileId: mobileIdRef.current,
    }, Token).then((res) => {
      setTimeout(() => {
        setCancelBtnRequestInProgress(false);
      }, 2000);
      setBalance(res.data.balance);
    })
      .catch((err) => {
        setCancelBtnRequestInProgress(false);
        console.log(err, "error saying");
        handleLogout(err);
      });
  };

  const handleNumber = () => {
    setLoading(true);
    setRequestInProgress(true);
    GenerateNumberAPI({ businessCode: selectService.code, server }, Token)
      .then((res) => {
        setTimeout(() => {
          setLoading(false);
          setRequestInProgress(false)
        }, 2000);
        if (res.data?.mobile[0]?.mobileno?.length < 10 || res.data.mobile[0] == undefined) {
          toast({
            title: res.data.message,
            status: "info",
            isClosable: true,
            duration: 1500,
          });
          return;
        }
        setResend(false);
        setRemainingTime(getInitialTime(server));
        setExpired(false);
        if (res.data.message != "Mobile phone number is initializing, please try again later" && Object.keys(res.data).length !== 0) {
          setBalance(res.data.balance);
          const serialNumber = res.data.mobile[0]?.serialNumber || "";
          const mobileno = res.data.mobile[0]?.mobileno || "";
          inputRef.current.value = mobileno;
          const mobileId = res.data.mobile[0]?._id || "";
          if (mobileId.length > 2) {
            setShowTime(true);
          }
          textAreaRef.current.value = "";
          setCurrentNumber({
            ...currentNumber,
            serialNumber,
            mobileId,
            mobileno,
          });
          serialNumberRef.current = serialNumber;
          mobileIdRef.current = mobileId;
          setTimeout(() => {
            startChecking();
          }, 500);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setLoading(false);
          setRequestInProgress(false)
        }, 2000);
        handleLogout(err);
        if (err.response?.data?.message === "User Doesn't have sufficient balance") {
          return;
        }
        setExpired(false);
        console.log(err, "error saying");
        setShowTime(false);
      });
  };
  useEffect(() => {
    if (remainingTime == 0) {
      setExpired(true);
      cancelBtn();
      setShowTime(false);
    }
    if (showTime && remainingTime > 0) {
      const intervalId = setInterval(() => {
        setRemainingTime(prevTime => prevTime - 1);
      }, 1000);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [showTime, remainingTime]);
  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    }
  }, [])
  return (
    <HStack
      p="0"
      w="100%"
      gap="0.3rem"
      border="1px solid transparent"
      align="start"
      flexDirection="row-reverse"
    >
      <HStack gap="0.2rem" flexDirection="column">
        <Button
          type="submit"
          p="1rem 1.6rem"
          w="5.8rem"
          fontSize="0.85rem"
          color="white"
          bgColor="#319795"
          border="2px solid #319795 !important"
          _hover={{
            bgColor: "white",
            color: "#319795",
          }}
          onClick={handleNumber}
          isDisabled={cancelBtnRequestInProgress || requestInProgress || loading}
        >
          {currentNumber.serialNumber ? "Buy Next" : "Get Number"}
        </Button>

        <Button
          type="submit"
          p="1rem 1.6rem"
          w="5.8rem"
          fontSize="0.85rem"
          color="white"
          bgColor="#dc2626"
          border="2px solid #dc2626 !important"
          m="0 !important"
          _hover={{
            bgColor: "#b91c1c",
            borderColor: "#b91c1c",
            color: "white",
          }}
          _disabled={{
            bgColor: "#fca5a5 !important",
            borderColor: "#fca5a5 !important",
            color: "white",
          }}
          onClick={cancelBtn}
          isDisabled={
            remainingTime > ((server == 'server5' || server === 'server3') ? 240 : server === "server1" ? 780 : 1080) ||
            requestInProgress ||
            cancelBtnRequestInProgress
          }
        >
          Cancel
        </Button>

        {server != "server3" && <Button
          p="1rem 1.6rem"
          w="5.8rem"
          fontSize="0.85rem"
          color="white"
          bgColor="#319795"
          border="2px solid #319795 !important"
          m="0 !important"
          _hover={{
            bgColor: "white",
            color: "#319795",
          }}
          isDisabled={!resend || resendLoading}
          onClick={() => {
            setResendLoading(true);
            setTimeout(() => {
              startChecking(true);
            }, 500);
          }}
        >
          Resend Otp
        </Button>}
      </HStack>

      {(showTime || expired) && <HStack w="20%">
        {expired && (
          <Text fontSize="0.8rem" fontWeight={600}>
            Number expired
          </Text>
        )}

        {showTime && (
          <Text
            fontSize="1rem"
            color={"rgb(220, 20, 60)"}
            fontWeight={600}
            textAlign="center"
            mt="0.8rem !important"
          >
            {formatTime(remainingTime)}
          </Text>
        )}
      </HStack>}

      <HStack
        flexDirection="column"
        gap="0.4rem"
        align="start"
        w="100%"
      >
        <InputGroup w="100%">
          <Input
            ref={inputRef}
            textAlign="start"
            readOnly
          />
          <InputRightElement>
            <Button
              bg="white"
              p="0 !important"
              h="96%"
              border="1px solid gray !important"
              color="#319795"
              onClick={CopyToClipBoard}
            >
              <FiCopy />
            </Button>
          </InputRightElement>Choose
        </InputGroup>

        <Textarea
          m="0 !important"
          ref={textAreaRef}
          readOnly
          placeholder="Otp will be shown here"
          size="sm"
          w="100%"
        />
      </HStack>
    </HStack>
  );
};

export default GetOtpCard;
